import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

const Cancelpolicy = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }, []);
  return (
    <>
      <section style={{ paddingTop: "5rem" }}>
        <Container>
          <div className="policy">
            <div className="privacy">
              <h2>Cancelation Policy</h2>
            </div>
            <h3>Order Cancellation Eligibility</h3>
            <p style={{ textIndent: "1.5rem" }}>
              {" "}
              Orders placed on www.VNEXTIT.in/Samsung.com can be canceled under
              the following conditions:
            </p>
            <ul>
              <li>
                Cancellation requests must be submitted before the order has
                been dispatched for delivery.
              </li>
              <li>
                Orders that have already been shipped cannot be canceled but may
                be eligible for return or exchange as per our Return and
                Exchange Policy.
              </li>
            </ul>
            <h3>How to Request a Cancellation</h3>
            <ul>
              <li>Log in to your account using your company email address.</li>
              <li>
                Navigate to the "My Orders" section and select the order you
                wish to cancel.
              </li>
              <li>
                Click on the "Cancel Order" button and follow the prompts to
                complete the cancellation request.
              </li>
              <li>
                You will receive an email confirmation once the cancellation
                request has been processed.
              </li>
            </ul>
            <h3>Refunds for Canceled Orders</h3>
            <ul>
              <li>
                If a payment has been made, refunds will be processed within 7
                business days of approval of the cancellation.
              </li>
              <li>
                Refunds will be credited back to the original payment method
                used during the purchase.
              </li>
            </ul>
            <h3>Conditions and Exceptions</h3>
            <ul>
              <li>
                Custom or special-order products may not be eligible for
                cancellation.
              </li>
              <li>
                Orders with specific terms mentioned at the time of purchase may
                be subject to different cancellation terms.
              </li>
            </ul>
            <h3>Cancellations Due to Errors</h3>
            <p>
              In case of pricing or product description errors,
              www.VNEXTIT.in/Samsung.com reserves the right to cancel any order.
              Customers will be notified, and any payments made will be fully
              refunded.
            </p>

            <h3>Contact Us</h3>
            <p>
              {" "}
              For assistance with cancellations, please reach out to our support
              team at enquiry@vnextit.in.
            </p>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Cancelpolicy;
